import React, { useState } from "react";
import CircularProgress from "./CircularProgress";
import { toAbsoluteUrl } from "_metronic/_helpers";
import { decideFileType } from "app/popleads/modules/activities/utils";
import SVG from "react-inlinesvg";
import styled from "styled-components";
import { colors } from "./colors";
import useDeleteAttachment from "app/popleads/hooks/useDeleteAttachment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmModal from "app/popleads/components/ui-kit/Modal";

export const Container = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    gap: 8px;
`;
// const StyledThubnail = styled.img`
//     width: 60px;
//     cursor: pointer;
//     height: 60px;
// `;

const Icon = styled.div`
    min-width: 18px;
`;

export const FileDetails = styled.div`
    display: flex;
    align-items: center;
    gap: 11px;
`;

export const FileName = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: ${colors.neutral[800]};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
`;

const DownloadIcon = styled.span`
    font-size: 10px;
    color: ${colors.primary[900]};
    cursor: pointer;
`;

const FileIconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export default function NotesFileCard({ attachments }) {
    // const [showModal, setShowModal] = useState(false);
    // const [selectedImage, setSelectedImage] = useState(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [selectedAttachmentId, setSelectedAttachmentId] = useState(null);

    const { deleteAttachment } = useDeleteAttachment();
    // const handleImageClick = (src) => {
    //     setSelectedImage(src);
    //     setShowModal(true);
    // };
    const handleDownload = (downloadLink, filename) => {
        if (!downloadLink) return;

        const anchorElement = document.createElement("a");
        anchorElement.href = downloadLink;
        anchorElement.download = filename || "download";
        anchorElement.target = "_blank";
        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
    };

    if (!attachments || !Array.isArray(attachments) || attachments.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-column mt-3">
            {attachments.map((attachment, index) =>
                attachment && attachment.filename ? (
                    <Container key={index}>
                        {/* {decideFileType(attachment.filename)?.includes("image") && (
                            <StyledThubnail
                                onClick={() => handleImageClick(attachment.downloadLink)}
                                src={attachment?.downloadLink}
                                alt="none"
                            />
                        )} */}

                        <Icon>
                            <SVG src={toAbsoluteUrl(decideFileType(attachment.filename))} />
                        </Icon>

                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id={`tooltip-${index}`}>{attachment.filename}</Tooltip>}
                        >
                            <FileName onClick={() => handleDownload(attachment.downloadLink, attachment.filename)}>
                                {attachment.filename}
                            </FileName>
                        </OverlayTrigger>

                        <FileIconContainer>
                            <CircularProgress
                                progress={100}
                                size={16}
                                color={"#0085BE"}
                                onClick={() => handleDownload(attachment.downloadLink, attachment.filename)}
                            >
                                <DownloadIcon className="material-symbols-outlined">arrow_downward</DownloadIcon>
                            </CircularProgress>

                            <span
                                className="material-symbols-outlined"
                                style={{ fontSize: "20px", cursor: "pointer" }}
                                onClick={() => {
                                    setConfirmModalOpen(true);
                                    setSelectedAttachmentId(attachment.id);
                                }}
                            >
                                close
                            </span>
                        </FileIconContainer>
                    </Container>
                ) : null
            )}
            {/* <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Body style={{ padding: 0, textAlign: "center" }}>
                    {selectedImage && (
                        <img src={selectedImage} alt="Preview" style={{ width: "100%", height: "auto" }} />
                    )}
                </Modal.Body>
            </Modal> */}
            <ConfirmModal
                isOpen={confirmModalOpen}
                onClose={() => {
                    setConfirmModalOpen(false);
                    setSelectedAttachmentId(null);
                }}
                title="Are you sure you want to delete this file?"
                variant="danger"
                icon="delete"
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onSuccess={() => {
                    deleteAttachment({ attachmentId: selectedAttachmentId });
                    setConfirmModalOpen(false);
                    setSelectedAttachmentId(null);
                }}
            >
                <div>This action cannot be undone.</div>
            </ConfirmModal>
        </div>
    );
}
